import React, { useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';

const HostForm = ({ t }) => {
  const [emailAddress, setEmailAddress] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [interests, setInterests] = useState([]);
  const [city, setCity] = useState('');

  const activities = [
    'Soccer', 'Volleyball', 'Hiking', 'Running',
    'Basketball', 'Surfing', 'Social Gathering', 'Chess'
  ];

  const toggleInterest = (activity) => {
    setInterests((prev) =>
      prev.includes(activity)
        ? prev.filter((a) => a !== activity)
        : [...prev, activity]
    );
  };
  const apiUrl = process.env.REACT_APP_API_URL;
  const onContactUsFormClicked = () => {
    // Validate email address
    if (!emailAddress || !firstName || !lastName || !phoneNumber) {
      toast("Please fill all the fields!",{
        position: "top-center",
        type: "error"
      });
      return;
    }

    if (!/\S+@\S+\.\S+/.test(emailAddress)) {
      toast("Please enter a valid email address!",{
        position: "top-center",
        type: "error"
      });
      return;
    }

    let description = `I would like to host a ${interests.join(', ')} event in ${city}. My phone number is ${phoneNumber}.`;
    fetch(`${apiUrl}/contact_us`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: emailAddress,
        first_name: firstName,
        last_name: lastName,
        description: description
      }),
    })
    .then(response => response.json())
    .then(data => {
      toast("We have received your message and will contact you within 72 hours. Thank you!",{
        position: "top-center",
        type: "success"
        });
    })
    .catch((error) => {
      console.error('Error:', error);
      toast("Something happened! Please try again!",{
        position: "top-center",
        type: "error"
        });
    });
    // clear the form
    setEmailAddress('');
    setFirstName('');
    setLastName('');
    setPhoneNumber('');
    setInterests([]);
  };

  return (
    <Container fluid style={styles.mainContainer}>
      <ToastContainer />
      <Container fluid style={styles.childContainer}>
        <Container fluid style={styles.container}>
          <Row style={styles.inputRow}>
            <label style={styles.inputTitle}>First Name</label>
            <input style={styles.input} type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
          </Row>

          <Row style={styles.inputRow}>
            <label style={styles.inputTitle}>Last Name</label>
            <input style={styles.input} type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
          </Row>

          <Row style={styles.inputRow}>
            <label style={styles.inputTitle}>Email Address</label>
            <input style={styles.input} type="email" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} />
          </Row>

          <Row style={styles.inputRow}>
            <label style={styles.inputTitle}>Phone Number</label>
            <input style={styles.input} type="tel" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
          </Row>

          <Row style={styles.inputRow}>
            <label style={styles.inputTitle}>City</label>
            <input style={styles.input} type="tel" value={city} onChange={(e) => setCity(e.target.value)} />
          </Row>

          <Row style={styles.inputRow}>
            <label style={styles.inputTitle}>What would you like to host?</label>
            <div style={styles.checkboxGroup}>
              {activities.map((activity) => (
                <label key={activity} style={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    checked={interests.includes(activity)}
                    onChange={() => toggleInterest(activity)}
                    style={{ marginRight: '8px' }}
                  />
                  {activity}
                </label>
              ))}
            </div>
          </Row>
        </Container>

        <Container fluid>
          <Row>
            <button style={styles.button} onClick={onContactUsFormClicked}>
              {'Submit'}
            </button>
          </Row>
        </Container>
      </Container>
    </Container>
  );
};

const styles = {
  mainContainer: { padding: '20px', backgroundColor: '#f8f9fa' },
  childContainer: { backgroundColor: '#fff', padding: '30px', borderRadius: '12px', maxWidth: '800px', margin: 'auto' },
  titleRow: { marginBottom: '20px', textAlign: 'center' },
  title: { fontSize: '24px', fontWeight: 'bold' },
  container: { marginBottom: '20px' },
  inputRow: { marginBottom: '15px', flexDirection: 'column' },
  inputTitle: { fontWeight: '600', marginBottom: '5px' },
  input: { padding: '10px', border: '1px solid #ccc', borderRadius: '6px', width: '100%' },
  checkboxGroup: { display: 'flex', flexWrap: 'wrap', gap: '10px' },
  checkboxLabel: { display: 'flex', alignItems: 'center', marginRight: '20px' },
  button: {
    marginTop: '20px',
    padding: '12px 24px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 'bold'
  }
};

export default HostForm;
